const doc = [({"ja":({"adminConstantHotelCheckInRequiredGuestInfoScope":({"onlyRepresentative":"代表者のみ", "allGuests":"利用者全員"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;